import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';
import { initGetAllStaffRequest } from '../store/action';

class ReAddWordTimeInSignInShiftBlock extends Component {
  constructor(props) {
    super(props);
    this.state={
      initTime : {
        expectedSignIntime:'',
        expectedSignOuttime:'',
        firstSignIntime: '',
        firstSignOuttime: '',
        secondSignIntime: '',
        secondSignOuttime: '',
        thirdSignIntime: '',
        thirdSignOuttime: '',
      },
      selectExpectedStartTime: moment('2018-09-08T10:00'),
      selectExpectedEndTime: moment('2018-09-08T10:00'), 
      selectFirstStartTime: moment('2018-09-08T10:00'),
      selectFirstEndTime: moment('2018-09-08T10:00'),
      selectSecondStartTime: moment('2018-09-08T10:00'),
      selectSecondEndTime: moment('2018-09-08T10:00'),
      selectThirdStartTime: moment('2018-09-08T10:00'),
      selectThirdEndTime: moment('2018-09-08T10:00'),
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleDeleteWorkTime = this.handleDeleteWorkTime.bind(this);

    this.handleAddSaveWorkTime = this.handleAddSaveWorkTime.bind(this);
    this.handleEditSaveWorkTime = this.handleEditSaveWorkTime.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    let {expectedSignIntime,expectedSignOuttime, firstSignIntime, firstSignOuttime, secondSignIntime, secondSignOuttime, thirdSignIntime, thirdSignOuttime, expectedDate} = nextProps.staffRecord;

    if (expectedDate === undefined) return;
    var initTimeObj = {
      expectedSignIntime: expectedSignIntime,
      expectedSignOuttime: expectedSignOuttime,
      firstSignIntime: firstSignIntime,
      firstSignOuttime:firstSignOuttime,
      secondSignIntime: secondSignIntime,
      secondSignOuttime: secondSignOuttime,
      thirdSignIntime: thirdSignIntime,
      thirdSignOuttime: thirdSignOuttime
    };
    //避免送出修改時，畫面會顯示舊資料
    if (
      initTimeObj.expectedSignIntime === this.state.initTime.expectedSignIntime &&
      initTimeObj.expectedSignOuttime === this.state.initTime.expectedSignOuttime &&
      initTimeObj.firstSignIntime === this.state.initTime.firstSignIntime &&
      initTimeObj.firstSignOuttime === this.state.initTime.firstSignOuttime &&
      initTimeObj.secondSignIntime === this.state.initTime.secondSignIntime &&
      initTimeObj.secondSignOuttime === this.state.initTime.secondSignOuttime &&
      initTimeObj.thirdSignIntime === this.state.initTime.thirdSignIntime &&
      initTimeObj.thirdSignOuttime === this.state.initTime.thirdSignOuttime
      ) return;

    this.setState({
      initTime: initTimeObj,
      selectExpectedStartTime: expectedSignIntime === "無資料" || expectedSignIntime === null ? null : moment(`${expectedDate}T${expectedSignIntime}`),
      selectExpectedEndTime: expectedSignOuttime === "無資料" || expectedSignOuttime === null ?  null : moment(`${expectedDate}T${expectedSignOuttime}`),
      selectFirstStartTime: firstSignIntime === "無資料" || firstSignIntime === null ? null : moment(`${expectedDate}T${firstSignIntime}`),
      selectFirstEndTime: firstSignOuttime === "無資料" || firstSignOuttime === null ?  null : moment(`${expectedDate}T${firstSignOuttime}`),
      selectSecondStartTime: secondSignIntime === "無資料" || secondSignIntime === null ?  null : moment(`${expectedDate}T${secondSignIntime}`),
      selectSecondEndTime: secondSignOuttime === "無資料" || secondSignOuttime === null ?  null :moment(`${expectedDate}T${secondSignOuttime}`),
      selectThirdStartTime: thirdSignIntime === "無資料" || thirdSignIntime === null ?  null : moment(`${expectedDate}T${thirdSignIntime}`),
      selectThirdEndTime: thirdSignOuttime === "無資料" || thirdSignOuttime === null ?  null :moment(`${expectedDate}T${thirdSignOuttime}`),
    })
  }
  handleSelectStartTimeChange(moment, type) {
    if (type === 1) {
      this.setState({
        selectFirstStartTime: moment
      })
    } else if (type === 2) {
      this.setState({
        selectSecondStartTime: moment
      })
    } else if (type === 3) {
      this.setState({
        selectThirdStartTime: moment
      })
    }else if (type === 4) {
      this.setState({
        selectExpectedStartTime: moment
      })
    } else {
      return
    }
  }

  handleSelectEndTimeChange(moment, type) {
    if (type === 1) {
      this.setState({
        selectFirstEndTime: moment
      })
    } else if (type === 2) {
      this.setState({
        selectSecondEndTime: moment
      })
    } else if (type === 3) {
      this.setState({
        selectThirdEndTime: moment
      })
    }else if (type === 4) {
      this.setState({
        selectExpectedEndTime: moment
      })
    } else {
      return
    }
  }
  handleDeleteWorkTime(eventId){
    this.props.deletePunchTimeFunc(eventId)
  }
  handleAddSaveWorkTime(type) { 
    const { staffRecord } = this.props;
    const { 
      selectExpectedStartTime,
      selectExpectedEndTime,
      selectFirstStartTime,
      selectFirstEndTime,
      selectSecondStartTime,
      selectSecondEndTime,
      selectThirdStartTime,
      selectThirdEndTime,
    } = this.state;

    var targetDate = moment(`${staffRecord.expectedDate}`)

    if(selectExpectedStartTime !== null)
      selectExpectedStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectExpectedEndTime !== null)
      selectExpectedEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())



    if(selectFirstStartTime !== null)
      selectFirstStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectFirstEndTime !== null)
      selectFirstEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectSecondStartTime !== null)
      selectSecondStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectSecondEndTime !== null)
      selectSecondEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectThirdStartTime !== null)
      selectThirdStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectThirdEndTime !== null)
      selectThirdEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    let data = {};
    if (type === 1) {
      if (
        //selectFirstEndTime === null || 
        selectFirstStartTime === null || (selectFirstEndTime !== null && selectFirstEndTime.diff(selectFirstStartTime) <= 0)) {
          console.log('1')

        swal({
          type: 'error',
          title: '時間輸入有誤',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      } 
      data = {
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectFirstStartTime.format("HH:mm:ss")}`,
        Status: 0
      }

      if(selectFirstEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectFirstEndTime.format("HH:mm:ss")}`;


    } else if (type === 2) {
      if (
        //selectSecondEndTime === null || 
        selectSecondStartTime === null ||(selectSecondEndTime !== null &&  selectSecondEndTime.diff(selectSecondStartTime) <= 0)) {
          console.log('2')

          swal({
            type: 'error',
            title: '時間輸入有誤',
            showConfirmButton: false,
            showCloseButton: true,
            heightAuto: false,
            width: '250px'
          });
          return;
        }
      data = {
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectSecondStartTime.format("HH:mm:ss")}`,
        Status: 0
      }

      
      if(selectSecondEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectSecondEndTime.format("HH:mm:ss")}`;

    } else if (type === 3) {
      if (
        //selectThirdEndTime === null || 
        selectThirdStartTime === null || (selectThirdEndTime !== null &&  selectThirdEndTime.diff(selectThirdStartTime) <= 0)) {
          console.log('3')

        swal({
          type: 'error',
          title: '時間輸入有誤',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      }
      data = {
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectThirdStartTime.format("HH:mm:ss")}`,
        Status: 0
      }

            
      if(selectThirdEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectThirdEndTime.format("HH:mm:ss")}`;
    } else if (type === 4) {
      if (
        //selectThirdEndTime === null || 
        selectExpectedStartTime === null || (selectExpectedEndTime !== null &&  selectExpectedEndTime.diff(selectExpectedStartTime) <= 0)) {
          console.log('4')

        swal({
          type: 'error',
          title: '時間輸入有誤',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      }
      data = {
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectExpectedStartTime.format("HH:mm:ss")}`,
        Status: 0
      }

            
      if(selectExpectedEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectExpectedEndTime.format("HH:mm:ss")}`;
    } else {
      return;
    }
    this.props.addPunchTimeFunc(data);
  }

  handleEditSaveWorkTime(type) {
    const { staffRecord} = this.props;
    const { 
      selectExpectedStartTime,
      selectExpectedEndTime,
      selectFirstStartTime,
      selectFirstEndTime,
      selectSecondStartTime,
      selectSecondEndTime,
      selectThirdStartTime,
      selectThirdEndTime,
    } = this.state;

    var targetDate = moment(`${staffRecord.expectedDate}`)

    if(selectExpectedStartTime !== null)
      selectExpectedStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectExpectedEndTime !== null)
      selectExpectedEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectFirstStartTime !== null)
      selectFirstStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectFirstEndTime !== null)
      selectFirstEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectSecondStartTime !== null)
      selectSecondStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectSecondEndTime !== null)
      selectSecondEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectThirdStartTime !== null)
      selectThirdStartTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())

    if(selectThirdEndTime !== null)
      selectThirdEndTime.year(targetDate.year()).month(targetDate.month()).date(targetDate.day())


    let data = {};
    if (type === 1) {
      if (
        //selectFirstEndTime === null || 
        selectFirstStartTime === null || (selectFirstEndTime!==null &&selectFirstEndTime.diff(selectFirstStartTime) <= 0)) {
        swal({
          type: 'error',
          title: '時間輸入有誤',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      }

      data = {
        Id: staffRecord.firstSignId,
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectFirstStartTime.format("HH:mm:ss")}`,
        Status: 0
      }

      if(selectFirstEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectFirstEndTime.format("HH:mm:ss")}`;

      this.setState({
        selectFirstEndTime: selectFirstEndTime,
        selectFirstStartTime: selectFirstStartTime,
      }
      , () => {
        this.props.editPunchTimeFunc(data);
      }
      )
    } else if (type === 2) {
      if (
        //selectSecondEndTime === null ||
         selectSecondStartTime === null || (selectSecondEndTime!==null &&selectSecondEndTime.diff(selectSecondStartTime) <= 0)) {
        swal({
          type: 'error',
          title: '時間輸入有誤',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      }
      data = {
        Id: staffRecord.secondSignId,
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectSecondStartTime.format("HH:mm:ss")}`,
        Status: 0
      }

      if(selectSecondEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectSecondEndTime.format("HH:mm:ss")}`;

      this.setState({
        selectSecondEndTime: selectSecondEndTime,
        selectSecondStartTime: selectSecondStartTime,
      }
      , () => {
        this.props.editPunchTimeFunc(data);
      }
      )
    } else if (type === 3) {
      if (
      //selectThirdEndTime === null || 
        selectThirdStartTime === null || (selectThirdEndTime!==null &&selectThirdEndTime.diff(selectThirdStartTime) <= 0)) {
        swal({
          type: 'error',
          title: '時間輸入有誤',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      }
      data = {
        Id: staffRecord.thirdSignId,
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectThirdStartTime.format("HH:mm:ss")}`,
        Status: 0
      }

      if(selectThirdEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectThirdEndTime.format("HH:mm:ss")}`;

      this.setState({
        selectThirdEndTime: selectThirdEndTime,
        selectThirdStartTime: selectThirdStartTime,
      }
      , () => {
        this.props.editPunchTimeFunc(data);
      }
      )
    }else if (type === 4) {
      if (
        //selectThirdEndTime === null || 
        selectExpectedStartTime === null || (selectExpectedEndTime !== null &&  selectExpectedEndTime.diff(selectExpectedStartTime) <= 0)) {
          console.log('4')

        swal({
          type: 'error',
          title: '時間輸入有誤',
          showConfirmButton: false,
          showCloseButton: true,
          heightAuto: false,
          width: '250px'
        });
        return;
      }
      data = {
        Id: staffRecord.eventId,
        UserId: staffRecord.id,
        StartAt: `${staffRecord.expectedDate}T${selectExpectedStartTime.format("HH:mm:ss")}`,
        Status: 0,
        IsExpectedEvent: true
      }

            
      if(selectExpectedEndTime !== null)
        data.EndAt = `${staffRecord.expectedDate}T${selectExpectedEndTime.format("HH:mm:ss")}`;

      this.setState({
        selectExpectedEndTime: selectExpectedEndTime,
        selectExpectedStartTime: selectExpectedStartTime,
      }
      , () => {
        this.props.editPunchTimeFunc(data);
      }
      )
    } else {
      return;
    }


    
  }


  render() {
    let { isVisible, toggleOpen, staffRecord } = this.props;
    let { expectedSignIntime, expectedSignOuttime, firstSignIntime, firstSignOuttime, secondSignIntime, secondSignOuttime, thirdSignIntime, thirdSignOuttime,
      firstSignId, secondSignId, thirdSignId} = staffRecord;
    if (!isVisible) {
      return null;
    }

    return (
      <div className="u-editblock fadeIn" onClick={toggleOpen}>
        <div className="form-block" onClick={(e)=>{e.stopPropagation();}}>
          <div className="u-small-title">補簽到編輯</div>
          <div className="u-edit-title">
            <div className="name">{`員工：${staffRecord.name}`}</div>
            <div className="expectedDate">{`預計上班日：${staffRecord.expectedDate}`}</div>
          </div>
          <form className="u-form">
          <div className="row">
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">預期簽到：</label>
                <DatePicker
                  id="date_picker_selectExpectedStartTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectExpectedStartTime}
                  onChange={(moment) => {this.handleSelectStartTimeChange(moment, 4)}}
                  className={ expectedSignIntime === "無資料" || expectedSignIntime === null ? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                    className={ expectedSignIntime === "無資料" || expectedSignIntime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectExpectedStartTime').click();
                    }}
                >
                  {this.state.selectExpectedStartTime === null ? '' : this.state.selectExpectedStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">預期簽退：</label>
                <DatePicker
                  id="date_picker_selectExpectedEndTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectExpectedEndTime}
                  onChange={(moment) => {this.handleSelectEndTimeChange(moment, 4)}}
                  className={ expectedSignOuttime === "無資料" || expectedSignOuttime === null ? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                    className={ expectedSignOuttime === "無資料" || expectedSignOuttime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectExpectedEndTime').click();
                    }}
                    disabled={!this.props.isRequestComplete}
                >
                  {this.state.selectExpectedEndTime === null ? '' : this.state.selectExpectedEndTime.format('HH:mm')}
                </button>
              </div> 
              <div className="col-2 col-pad-12 flex-start-end">
                <button className="btn btn-md success"disabled={!this.props.isRequestComplete} onClick={(e) => {
                  e.preventDefault();
                  this.handleEditSaveWorkTime(4);
                }}>儲存</button>
                  {/* <button className={`btn btn-md delete ${firstSignId === "無資料" ? "disabled" : ""}`} disabled={firstSignId === "無資料"} onClick={(e) => {
                  //this.setState({firstDisable:true})
                  e.preventDefault();
                  this.handleDeleteWorkTime(firstSignId);
                }}>刪除</button> */}
              </div>
            </div>
            <div className="row">
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">第一段簽到：</label>
                <DatePicker
                  id="date_picker_selectFirstStartTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectFirstStartTime}
                  onChange={(moment) => {this.handleSelectStartTimeChange(moment, 1)}}
                  className={ firstSignIntime === "無資料" || firstSignIntime === null ? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                    className={ firstSignIntime === "無資料" || firstSignIntime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectFirstStartTime').click();
                    }}
                >
                  {this.state.selectFirstStartTime === null ? '' : this.state.selectFirstStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">第一段簽退：</label>
                <DatePicker
                  id="date_picker_selectFirstEndTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectFirstEndTime}
                  onChange={(moment) => {this.handleSelectEndTimeChange(moment, 1)}}
                  className={ firstSignOuttime === "無資料" || firstSignOuttime === null ? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                    className={ firstSignOuttime === "無資料" || firstSignOuttime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectFirstEndTime').click();
                    }}
                    disabled={!this.props.isRequestComplete}
                >
                  {this.state.selectFirstEndTime === null ? '' : this.state.selectFirstEndTime.format('HH:mm')}
                </button>
              </div> 
              <div className="col-2 col-pad-12 flex-start-end">
                <button className="btn btn-md success"disabled={!this.props.isRequestComplete} onClick={(e) => {
                  e.preventDefault();
                  if (firstSignIntime === "無資料" && firstSignOuttime === "無資料") {
                    this.handleAddSaveWorkTime(1);
                  } else {
                    this.handleEditSaveWorkTime(1);
                  }
                }}>儲存</button>
                  <button className={`btn btn-md delete ${firstSignId === "無資料" ? "disabled" : ""}`} disabled={firstSignId === "無資料"} onClick={(e) => {
                  //this.setState({firstDisable:true})
                  e.preventDefault();
                  this.handleDeleteWorkTime(firstSignId);
                }}>刪除</button>
              </div>
            </div>
            <div className="row">
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">第二段簽到：</label>
                <DatePicker
                  id="date_picker_selectSecondStartTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectSecondStartTime}
                  onChange={(moment) => {this.handleSelectStartTimeChange(moment, 2)}}
                  className={ secondSignIntime === "無資料" || secondSignIntime === null? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                    className={ secondSignIntime === "無資料" || secondSignIntime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectSecondStartTime').click();
                    }}
                >
                  {this.state.selectSecondStartTime === null ? '' : this.state.selectSecondStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">第二段簽退：</label>
                <DatePicker
                  id="date_picker_selectSecondEndTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectSecondEndTime}
                  onChange={(moment) => {this.handleSelectEndTimeChange(moment, 2)}}
                  className={ secondSignOuttime === "無資料" || secondSignOuttime === null? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                    className={ secondSignOuttime === "無資料" || secondSignOuttime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectSecondEndTime').click();
                    }}
                >
                  {this.state.selectSecondEndTime === null ? '' : this.state.selectSecondEndTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-2 col-pad-12 flex-start-end">
              <button className="btn btn-md success" disabled={!this.props.isRequestComplete} onClick={(e) => {
                  e.preventDefault();
                  if (secondSignIntime === "無資料" && secondSignOuttime=== "無資料") {
                    this.handleAddSaveWorkTime(2);
                  } else {
                    this.handleEditSaveWorkTime(2);
                  }
                }}>儲存</button>
                  <button className={`btn btn-md delete ${secondSignId === "無資料" ? "disabled" : ""}`} disabled={secondSignId === "無資料"} onClick={(e) => {
                  e.preventDefault();
                  this.handleDeleteWorkTime(secondSignId);
                }}>刪除</button>
              </div>
            </div>
            <div className="row">
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">第三段簽到：</label>
                <DatePicker
                  id="date_picker_selectThirdStartTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectThirdStartTime}
                  onChange={(moment) => {this.handleSelectStartTimeChange(moment, 3)}}
                  className={ thirdSignIntime === "無資料" || thirdSignIntime === null? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                    className={ thirdSignIntime === "無資料" || thirdSignIntime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectThirdStartTime').click();
                    }}
                >
                  {this.state.selectThirdStartTime === null ? '' : this.state.selectThirdStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-5 col-pad-12">
                <label className="u-form__label text-align-right">第三段簽退：</label>
                <DatePicker
                  id="date_picker_selectThirdEndTime"
                  locale="zh-tw"
                  autocomplete="off"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  timeIntervals={1}
                  selected={this.state.selectThirdEndTime}
                  onChange={(moment) => {this.handleSelectEndTimeChange(moment, 3)}}
                  className={ thirdSignOuttime === "無資料" || thirdSignOuttime === null? 'u-form__input not_signin mobile-hide' : 'u-form__input mobile-hide' }
                />
                <button
                     className={ thirdSignOuttime === "無資料" || thirdSignOuttime === null ? 'btn datepickinput desktop--hide not_signin' : 'btn datepickinput desktop--hide' }
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('date_picker_selectThirdEndTime').click();
                    }}
                >
                  {this.state.selectThirdEndTime === null ? '' : this.state.selectThirdEndTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-2 col-pad-12 flex-start-end">
              <button className="btn btn-md success" disabled={!this.props.isRequestComplete}  onClick={(e) => {
                  e.preventDefault();
                  if (thirdSignIntime === "無資料" && thirdSignOuttime === "無資料") {
                    this.handleAddSaveWorkTime(3);
                  } else {
                    this.handleEditSaveWorkTime(3);
                  }
                }}>儲存</button>
                <button className={`btn btn-md delete ${thirdSignId === "無資料" ? "disabled" : ""}`} disabled={thirdSignId === "無資料"} onClick={(e) => {
                  //this.setState({firstDisable:true})
                  e.preventDefault();
                  this.handleDeleteWorkTime(thirdSignId);
                }}>刪除</button>
              </div>
            </div>
            <div className="u-notice">※此功能僅限處理漏打卡事件</div>
            <div className="u-notice">※修改一次時間算一次漏打卡</div>
            <div className="u-notice">※新增一筆簽到退時間算兩次漏打卡</div>

            <div className="u-btn-group right p-0">
              <button className="btn btn-md cancel m-0" onClick={
                (e) => {
                  e.preventDefault();
                  toggleOpen();
                }
              }>取消</button>
              </div>
          </form>
        </div>
      </div>
    )
  }
}

export default ReAddWordTimeInSignInShiftBlock;